/* @NOTE Contents of this file is *generated*, DO NOT EDIT */

export const examples = {
	'docs/authentication': {
		token: {
			go: () =>
				import('..\u002F..\u002F..\u002Fdocs\u002Fauthentication\u002F_examples\u002Ftoken.go?raw'),
			java: () =>
				import('..\u002F..\u002F..\u002Fdocs\u002Fauthentication\u002F_examples\u002Ftoken.java?raw'),
			js: () =>
				import('..\u002F..\u002F..\u002Fdocs\u002Fauthentication\u002F_examples\u002Ftoken.js?raw'),
			sh: () =>
				import('..\u002F..\u002F..\u002Fdocs\u002Fauthentication\u002F_examples\u002Ftoken.sh?raw'),
		},
	},
	'docs/keys': {
		rotate: {
			go: () =>
				import('..\u002F..\u002F..\u002Fdocs\u002Fkeys\u002F_examples\u002Frotate.go?raw'),
			java: () =>
				import('..\u002F..\u002F..\u002Fdocs\u002Fkeys\u002F_examples\u002Frotate.java?raw'),
			js: () =>
				import('..\u002F..\u002F..\u002Fdocs\u002Fkeys\u002F_examples\u002Frotate.js?raw'),
			sh: () =>
				import('..\u002F..\u002F..\u002Fdocs\u002Fkeys\u002F_examples\u002Frotate.sh?raw'),
		},
	},
	'reference/keys/rotate': {
		request: {
			go: () =>
				import('..\u002F..\u002F..\u002Freference\u002Fkeys\u002Frotate\u002F_examples\u002Frequest.go?raw'),
			java: () =>
				import('..\u002F..\u002F..\u002Freference\u002Fkeys\u002Frotate\u002F_examples\u002Frequest.java?raw'),
			js: () =>
				import('..\u002F..\u002F..\u002Freference\u002Fkeys\u002Frotate\u002F_examples\u002Frequest.js?raw'),
			sh: () =>
				import('..\u002F..\u002F..\u002Freference\u002Fkeys\u002Frotate\u002F_examples\u002Frequest.sh?raw'),
		},
	},
	'reference/oauth/token': {
		request: {
			go: () =>
				import('..\u002F..\u002F..\u002Freference\u002Foauth\u002Ftoken\u002F_examples\u002Frequest.go?raw'),
			java: () =>
				import('..\u002F..\u002F..\u002Freference\u002Foauth\u002Ftoken\u002F_examples\u002Frequest.java?raw'),
			js: () =>
				import('..\u002F..\u002F..\u002Freference\u002Foauth\u002Ftoken\u002F_examples\u002Frequest.js?raw'),
			sh: () =>
				import('..\u002F..\u002F..\u002Freference\u002Foauth\u002Ftoken\u002F_examples\u002Frequest.sh?raw'),
		},
	},
	'reference/users/fields': {
		request: {
			go: () =>
				import('..\u002F..\u002F..\u002Freference\u002Fusers\u002Ffields\u002F_examples\u002Frequest.go?raw'),
			java: () =>
				import('..\u002F..\u002F..\u002Freference\u002Fusers\u002Ffields\u002F_examples\u002Frequest.java?raw'),
			js: () =>
				import('..\u002F..\u002F..\u002Freference\u002Fusers\u002Ffields\u002F_examples\u002Frequest.js?raw'),
			sh: () =>
				import('..\u002F..\u002F..\u002Freference\u002Fusers\u002Ffields\u002F_examples\u002Frequest.sh?raw'),
		},
	},
	'reference/users/list': {
		request: {
			go: () =>
				import('..\u002F..\u002F..\u002Freference\u002Fusers\u002Flist\u002F_examples\u002Frequest.go?raw'),
			java: () =>
				import('..\u002F..\u002F..\u002Freference\u002Fusers\u002Flist\u002F_examples\u002Frequest.java?raw'),
			js: () =>
				import('..\u002F..\u002F..\u002Freference\u002Fusers\u002Flist\u002F_examples\u002Frequest.js?raw'),
			sh: () =>
				import('..\u002F..\u002F..\u002Freference\u002Fusers\u002Flist\u002F_examples\u002Frequest.sh?raw'),
		},
	},
};
